import Model from './Model'

export default class S3Bucket extends Model {

  get attributes () {
    return [
      'name',
      'createAt',
      'type',
      'accountName',
      'accountID'
    ]
  }

  constructor (data) {
    super(data)

    this.name = data.Name
    this.createAt = data.CreationDate.toLocaleString('ru')
    this.checked = false
    this.type = 'bucket'
  }

  set checked (state) {
    state = !!state
    this.__checked = state
    this.checkedTime = state ? Date.now() : 0
  }

  get checked () {
    return this.__checked
  }
}
